function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var AmexFull = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  height: "100%",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H24V24H0V0Z",
    fill: "#016FD0"
  }), /*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.69434 20.2024V11.6028L24.0003 11.6165V13.992L22.2313 15.8825L24.0003 17.7904V20.2163H21.1758L19.6747 18.5599L18.1843 20.2227L8.69434 20.2024Z",
    fill: "white"
  }), /*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.7168 19.2596V12.5492H15.4067V14.0949H11.5591V15.1443H15.3149V16.6645H11.5591V17.6952H15.4067V19.2596H9.7168Z",
    fill: "#016FD0"
  }), /*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3779 19.2596L18.5263 15.9005L15.3779 12.5493H17.8147L19.7386 14.6761L21.6679 12.5493H24.0001V12.6021L20.9187 15.9005L24.0001 19.1644V19.2596H21.6445L19.6865 17.1115L17.7486 19.2596H15.3779Z",
    fill: "#016FD0"
  }), /*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.4075 3.96986H13.097L14.3928 6.91239V3.96986H18.9478L19.7332 6.17452L20.5214 3.96986H23.9995V12.5695H5.61816L9.4075 3.96986Z",
    fill: "white"
  }), /*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1064 4.90415L7.12891 11.6089H9.17104L9.73277 10.2663H12.7765L13.3378 11.6089H15.4308L12.4657 4.90415H10.1064ZM10.3622 8.76162L11.2552 6.62722L12.1474 8.76162H10.3622Z",
    fill: "#016FD0"
  }), /*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4033 11.6077V4.90307L18.2739 4.91294L19.7509 9.03481L21.2376 4.90307H24.0003V11.6079L22.2225 11.6235V7.01787L20.5444 11.6079H18.9217L17.2088 7.00227V11.6079L15.4033 11.6077Z",
    fill: "#016FD0"
  })]
}));
//# sourceMappingURL=AmexFull.js.map